import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';

import { dcbAtom } from '@shared/store/slice-atoms';
import { APP_THEMES } from '@shared/config/constants/app';
import { setTheme } from '@shared/utils/general';
import {
  PT_CC_EMAIL,
  PT_CC_PHONE,
  PT_DEFAULT_WEEKLY_PRICE,
  PT_SERVICE_LOGO,
  PT_TERMS_URL,
  PT_UNSUBSCRIBE_PATH,
} from '@shared/config/constants/portugal';
import { LogService, EVENT_NAMES } from '@shared/services/LogService';
import styles from '../../styles/ThankyouPTWelcomeTexts.module.css';

const formatWeeklyPrice = (rawPrice?: string | number | null) => {
  if (!rawPrice && rawPrice !== 0) return PT_DEFAULT_WEEKLY_PRICE;

  const asString = String(rawPrice).trim();
  if (!asString) return PT_DEFAULT_WEEKLY_PRICE;
  if (asString.includes('€') || asString.toLowerCase().includes('semana')) return asString;

  return `${asString}€`;
};

export const ThankyouPTWelcomeTexts = () => {
  const { t } = useTranslation();
  const dcb = useAtomValue(dcbAtom);
  const { thankyouData, operatorSelectedDetails } = dcb as any;

  const weeklyPrice = formatWeeklyPrice(
    thankyouData?.weeklyPrice ||
      thankyouData?.price ||
      operatorSelectedDetails?.weeklyText ||
      operatorSelectedDetails?.weeklyPrice
  );

  useEffect(() => {
    setTheme(APP_THEMES.WHITE);
  }, []);

  const handleTermsClick = () => {
    LogService.handleEvent(EVENT_NAMES.main_click_button_terms_and_conditions);
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <img src={PT_SERVICE_LOGO} className={styles.logo} alt="VUZ VIP" />
      </header>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('welcome_pt_title')}</h1>
        <p className={styles.body}>
          {t('welcome_pt_body', { price: weeklyPrice })}{' '}
          <Link className={styles.cancelLink} to={PT_UNSUBSCRIBE_PATH}>
            {t('welcome_pt_cancel_here')}
          </Link>{'.'}
        </p>
        <p className={styles.contacts}>
          {t('welcome_pt_cc_phone')}: {PT_CC_PHONE}
        </p>
        <p className={styles.contacts}>
          {t('welcome_pt_cc_email')}:{' '}
          <a href={`mailto:${PT_CC_EMAIL}`}>{PT_CC_EMAIL}</a>
        </p>
        <a
          className={styles.terms}
          href={PT_TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleTermsClick}
        >
          {t('terms_and_conditions')}
        </a>
      </div>
    </div>
  );
};
